<div class="p-(--padding-card)">
  <ces-route-title [count]="eventLogs.length" />

  @if (showJobs()) {
    <div class="mb-4 rounded-lg border border-orange-300 bg-orange-50 p-4">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-semibold text-orange-800">Calcul Jobs</h3>
        <button type="button" class="text-xs text-orange-600 hover:underline" (click)="loadJobs()">↻ Refresh</button>
      </div>
      @if (jobsLoading()) {
        <p class="text-xs text-orange-600">Chargement...</p>
      } @else {
        <!-- Active jobs (todo + ongoing) -->
        @if (activeJobs().length > 0) {
          <div class="mb-3">
            <h4 class="text-xs font-medium text-orange-700 mb-1">En cours ({{ activeJobs().length }})</h4>
            <div class="overflow-auto max-h-40">
              <table class="w-full text-xs">
                <thead class="bg-orange-100">
                  <tr>
                    <th class="px-2 py-1 text-left">ID</th>
                    <th class="px-2 py-1 text-left">Action</th>
                    <th class="px-2 py-1 text-left">Status</th>
                    <th class="px-2 py-1 text-left">Measure</th>
                    <th class="px-2 py-1 text-left">Message</th>
                    <th class="px-2 py-1 text-left">Créé</th>
                  </tr>
                </thead>
                <tbody>
                  @for (job of activeJobs(); track job.id) {
                    <tr class="border-b border-orange-100">
                      <td class="px-2 py-1">{{ job.id }}</td>
                      <td class="px-2 py-1">{{ job.action }}</td>
                      <td class="px-2 py-1">
                        <span [class]="job.status === 'ongoing' ? 'text-blue-600 font-medium' : 'text-orange-600'">
                          {{ job.status }}
                        </span>
                      </td>
                      <td class="px-2 py-1">{{ job.measureId }}</td>
                      <td class="px-2 py-1 max-w-48 truncate">{{ job.message }}</td>
                      <td class="px-2 py-1">{{ job.created | date: 'dd.MM.yyyy HH:mm' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        } @else {
          <p class="text-xs text-gray-500 mb-3">Aucun job en attente.</p>
        }

        <!-- Recent jobs (completed + error, last 10) -->
        @if (recentJobs().length > 0) {
          <div>
            <h4 class="text-xs font-medium text-gray-600 mb-1">Récents (10 derniers)</h4>
            <div class="overflow-auto max-h-40">
              <table class="w-full text-xs">
                <thead class="bg-gray-100">
                  <tr>
                    <th class="px-2 py-1 text-left">ID</th>
                    <th class="px-2 py-1 text-left">Action</th>
                    <th class="px-2 py-1 text-left">Status</th>
                    <th class="px-2 py-1 text-left">Measure</th>
                    <th class="px-2 py-1 text-left">Message</th>
                    <th class="px-2 py-1 text-left">Créé</th>
                  </tr>
                </thead>
                <tbody>
                  @for (job of recentJobs(); track job.id) {
                    <tr class="border-b border-gray-100">
                      <td class="px-2 py-1">{{ job.id }}</td>
                      <td class="px-2 py-1">{{ job.action }}</td>
                      <td class="px-2 py-1">
                        <span
                          [class]="
                            job.status === 'error' ? 'text-red-600 font-medium' : job.status === 'completed' ? 'text-green-600' : ''
                          ">
                          {{ job.status }}
                        </span>
                      </td>
                      <td class="px-2 py-1">{{ job.measureId }}</td>
                      <td class="px-2 py-1 max-w-48 truncate">{{ job.message }}</td>
                      <td class="px-2 py-1">{{ job.created | date: 'dd.MM.yyyy HH:mm' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <p class="text-xs text-gray-400 mt-2">Ctrl+Shift+J pour masquer</p>
      }
    </div>
  }

  <ces-generic-parent-grid
    [dataLoadingCompleted]="true"
    [entities]="eventLogs()"
    [paginator]="true"
    [selectionMode]="false"
    [totalRecords]="totalRecords()"
    [first]="first()"
    [rows]="rows()"
    [initialFilters]="urlFilters()"
    (lazyLoad)="onLazyLoad($event)"
    [entityDefinition]="eventLogDefinition" />
</div>
